import { ZonedDateTime, DateTimeFormatter, LocalDateTime } from "@js-joda/core";

export function shortDateFromString(date) {
  if (!date) return "";
  const format = DateTimeFormatter.ofPattern("dd/MM/y");
  const from = ZonedDateTime.parse(`${date}Z`);
  return from.format(format);
}

export function shortDateTimeFromString(date) {
  if (!date) return "";
  const format = DateTimeFormatter.ofPattern("dd/MM/y HH:mm");
  const from = ZonedDateTime.parse(`${date}Z`);
  return from.format(format);
}

export function shortDateFromDate(date) {
  if (!date) return "";
  const format = DateTimeFormatter.ofPattern("dd/MM/y");
  return date.format(format);
}

export function parseDate(date) {
  if (!date) return "";
  return LocalDateTime.parse(date);
}
export function dayFromStringDatetime(date) {
  if (!date) return "";
  const newdate = date.substring(0, date.indexOf("T"));
  const items = newdate.split("-");
  const dateformat = items[2] + "-" + items[1] + "-" + items[0];
  return dateformat;
}

export function getDate(date) {
  let _date = date;
  if (date && !(date instanceof Date)) _date = new Date(date);
  return _date;
}
